export const DEVICE = 'device';

export enum DEVICES {
  IPHONE = 'iphone',
}
